<div class="w-100 h-100 p-3 d-flex flex-column">
    <div>
        <span class="subtitle-1" cvLocalizedText langSection="Assign_Tool" langKey="Assigned_To">Assigned to:</span>
    </div>
    <div class="groups-separator"></div>
    <div class="subtitle-1 font-weight-bold py-3" cvLocalizedText langSection="Assign_Tool" langKey="Call_Groups">Contact Group(s)</div>
    <div class="subtitle-2" *ngIf="recGroups.length > 0">
        {{currentGroupType}}
    </div>
    <div class="flex-fill d-flex flex-column overflow-auto">
        <div class="d-flex flex-column">
            <div class="px-3" *ngIf="recGroups.length == 0">
                <span cvLocalizedText langSection="Assign_Tool" langKey="All_Rec_Groups">All Rec Groups</span>
            </div>
            <div class="group-item py-2 px-3 d-flex flex-row align-items-center" *ngFor="let groupDTO of recGroups; trackBy: trackByGroupID">
                <div class="text-truncate flex-fill pr-2" [attr.title]="groupDTO.GroupName">
                    - {{groupDTO.GroupName}}
                </div>
                <button type="button" class="icon-btn remove-button" (click)="removeGroup(groupDTO)">
                    <img src="../App_Themes/clearview-default/icons/utility/remove-16px.svg" style="width: 16px; height: 16px;">
                </button>
            </div>
        </div>
    </div>
</div>
